export enum SpecialWalletType {
	Deposit = 1,
	InternalTransfer = 2
}
